import { TrainingOfferingData } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { ListFieldInfo } from '../../../common/list/list-types';
import { SkillListEntry } from '../skill-lists/skill-list-view';
import { SkillTrainingOfferingListEntry } from './skill-training-offering-list-view';

/// View driven from TrainingOffering to list of Skills
export const TrainingOfferingToSkillListView: ListFieldInfo<SkillTrainingOfferingListEntry, TrainingOfferingData>[] = [
  {
    name: 'skillName',
    label: 'Skill Name',
    kind: 'mappedLink',
    map: (entry, data) => {
      if (data) {
        const skill = data.skills.find(item => item.id === entry.skillId);
        if (skill) {
          return skill.value.name;
        }
      }
      return 'notfound';
    },
    displayed: true,
    sortable: true,
    searchable: true,
    searchOption: (entry, data) => {
      if (data) {
        const skill = data.skills.find(item => item.id === entry.skillId);
        if (skill) {
          return { label: skill.value.name, value: skill.id };
        }
      }
      return undefined;
    },
    filterField: 'skillId'
  },
  {
    name: 'skillDefinition',
    label: 'Skill Definition',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const skill = data.skills.find(item => item.id === entry.skillId);
        if (skill) {
          return skill.value.definition;
        }
      }
      return 'notfound';
    },
    displayed: true,
    sortable: false,
    searchable: false
  },
  {
    name: 'method',
    label: 'Relevance',
    kind: 'action',
    fieldType: 'number',
    read: entry => {
      return entry.method.kind === 'relevance' ? (entry.method.value as number) : '';
    },
    displayed: true,
    align: 'centre'
  },
  {
    name: 'deleteSkillTrainingOffering',
    label: 'Remove',
    kind: 'delete',
    displayed: true,
    align: 'centre'
  }
];

export const UnassignedSkillListView: ListFieldInfo<SkillListEntry, undefined>[] = [
  {
    name: 'name',
    label: 'Skill Name',
    kind: 'i18nTextLink',
    displayed: true,
    sortable: true,
    searchable: true,
  },
  {
    name: 'definition',
    label: 'Definition',
    kind: 'i18nText',
    displayed: true,
    sortable: true
  },
  {
    name: 'removeSkillFromUnassignedList',
    label: 'Add Skill',
    kind: 'delete',
    displayed: true,
    align: 'centre'
  }
];

export const AssignedSkillsView: ListFieldInfo<SkillTrainingOfferingListEntry, TrainingOfferingData>[] = [
  {
    name: 'name',
    label: 'Linked Skill Name',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const skill = data.skills.find(sk => sk.id === entry.skillId);
        if (skill) return skill.value.name;
      }
      return 'notfound';
    },
    displayed: true,
    sortable: false,
    searchable: false,
  },
  {
    name: 'competencyName',
    label: 'Competency',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const skill = data.skills.find(sk => sk.id === entry.skillId);
        if (skill) {
          const competency = data.competencies.find(c => c.id === skill.value.competencyId);
          if (competency) return competency.value.name;}
          return 'notfound';
      }
      return 'notfound';
    },
    displayed: true,
    sortable: false,
  },
  {
    name: 'method',
    label: 'Relevance',
    kind: 'mapped',
    map: (entry) => {
      return entry.method.kind === 'relevance' ? (entry.method.value) : '';
    },
    displayed: true,
    sortable: false,
  },
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/training-offering-lists/training-offering-to-skill-list-view.ts